import React from 'react'

import {
    HDatePicker,
    HInput,
    passParamsThrough
} from '../../../validation/HForm'

const UserAttorneyAdd = (props) => {

    return ( passParamsThrough (
        <div>
            <div className="form-row">
                <div className="form-row-item">
                    <div className="form-element">
                        <label className="form-element-label" htmlFor="attorneyNumber">Номер</label>
                        <div className="form-element-data">
                            <HInput 
                                h="true" 
                                className="input" 
                                type="text" 
                                name="user.attorney.attorneyNumber" 
                                id="attorneyNumber" 
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="form-row">
                <div className="form-row-item">
                    <div className="form-element">
                        <label className="form-element-label" htmlFor="attorneyDate">Дата</label>
                        <div className="form-element-data date">
                            <HDatePicker 
                                h="true" 
                                className="input" 
                                name="user.attorney.attorneyDate"
                                id="attorneyDate" 
                            />
                        </div>
                    </div>
                </div>
                <div className="form-row-item">
                    <div className="form-element">
                        <label className="form-element-label" htmlFor="attorneyDate">Срок действия</label>
                        <div className="form-element-data date">
                            <HDatePicker 
                                h="true" 
                                className="input" 
                                name="user.attorney.attorneyEndDate"
                                id="attorneyEndDate" 
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>, props )
    )
}

export default UserAttorneyAdd
